import { render } from "./ResearchPage.vue?vue&type=template&id=80e96eaa&scoped=true"
const script = {}

import "./ResearchPage.vue?vue&type=style&index=0&id=80e96eaa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e96eaa"]])

export default __exports__